module.exports = __webpack_public_path__ + "cc34f361cb2a690d32ee80690af6f22a.pdf";